// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleParticipantsButton_deviceButton__bizbj","icon":"ToggleParticipantsButton_icon__3DNnp","badge":"ToggleParticipantsButton_badge__rMa+A"};